// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { ExpandDoubleVector } from '../DoubleMatrix';
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class UO extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'UO';
        this.Comments = 'Ultimate Oscillator';
        super.SetIndicatorLine('uo', Color.Blue, 2, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.FastInterval = 7;
        super.InputParameter(new InputParameterInteger('FastInterval', 'Fast interval', 0, 1, 9999));
        this.MiddleInterval = 14;
        super.InputParameter(new InputParameterInteger('MiddleInterval', 'Middle interval', 0, 1, 9999));
        this.SlowInterval = 28;
        super.InputParameter(new InputParameterInteger('SlowInterval', 'Slow interval', 0, 1, 9999));
        this.bp = new ExpandDoubleVector();
        this.tr = new ExpandDoubleVector();
        this.avarage = new ExpandDoubleVector();
        this.avarageMiddle = new ExpandDoubleVector();
        this.avarageSlow = new ExpandDoubleVector();
    }
    Init() {
        super.Init();
        super.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'UO(' + this.FastInterval + ',' + this.MiddleInterval + ',' + this.SlowInterval + ')';
    }
    getCustomName() {
        return 'UO (' + this.ProjectName + ')';
    }
    NextBar() {
        this.bp.Add(0.0);
        this.tr.Add(0.0);
        this.avarage.Add(0.0);
        this.avarageMiddle.Add(0.0);
        this.avarageSlow.Add(0.0);
        super.NextBar();
    }
    OnQuote() {
        super.OnQuote();
        if (this.CurrentData.Count - 1 <= 1) {
            return;
        }
        this.setBP();
        this.setTR();
        this.setAvarage();
        this.setAvarageMiddle();
        this.setAvarageSlow();
        super.SetValue(0, 0, this.getUO());
    }
    setBP() {
        this.bp[this.bp.Length - 1] =
            this.CurrentData.getPriceByType(PriceType.Close) -
                Math.min(this.CurrentData.getPriceByType(PriceType.Close, 1), this.CurrentData.getPriceByType(PriceType.Low));
    }
    setTR() {
        this.tr[this.tr.Length - 1] =
            Math.max(this.CurrentData.getPriceByType(PriceType.Close, 1), this.CurrentData.getPriceByType(PriceType.High)) - this.bp[this.bp.Length - 1];
    }
    setAvarage() {
        this.avarage[this.avarage.Length - 1] = this.getAvarage(this.FastInterval);
    }
    setAvarageMiddle() {
        this.avarageMiddle[this.avarageMiddle.Length - 1] = this.getAvarage(this.MiddleInterval);
    }
    setAvarageSlow() {
        this.avarageSlow[this.avarageSlow.Length - 1] = this.getAvarage(this.SlowInterval);
    }
    getAvarage(interval) {
        let sumBP = 0;
        let sumTR = 0;
        for (let index = 0; index < interval; index++) {
            sumBP += this.bp[this.bp.Length - 1 - index];
            sumTR += this.tr[this.tr.Length - 1 - index];
        }
        return sumBP / sumTR;
    }
    getUO() {
        const result = (100 *
            (this.avarage[this.avarage.Length - 1] * 4 +
                this.avarageMiddle[this.avarageMiddle.Length - 1] * 2 +
                this.avarageSlow[this.avarageSlow.Length - 1])) /
            7;
        return result;
    }
}
